import React, { useState } from 'react';
import { SIMPLModal } from '../dialog/SIMPLModal';
import { SIMPLButtonCustomized } from '../button/SIMPLButtonCustumized';
import { useTranslation } from 'react-i18next';
import { RequesterInfo } from '~/models/types/ContractsTypes';
import DecommissionStatus from '~/models/enums/DecommissionStatus.enum';

interface Props {
  item: RequesterInfo;
  onCancel: () => void;
  onConfirm: () => void;
  onSave: () => void;
  isLoading: boolean;
  isApplyMode?: boolean;
}

export const FillOutputMessageModal: React.FC<Props> = ({
  item,
  onCancel,
  onConfirm,
  onSave,
  isLoading,
  isApplyMode,
}) => {
  const { t } = useTranslation();
  const [hasSaved, setHasSaved] = useState<boolean>(isApplyMode ?? false);

  const isRenewal = item.resourceStatus === DecommissionStatus.RENEWAL_CREDENTIALS;

  const title = isApplyMode
    ? t('ApplyOutputMessage')
    : t('FillOutputMessageTitle');

  const description = isRenewal
    ? t('RenewalCredentialsDescription')
    : t('FillOutputMessageDescription');

  const confirmLabel = t('ApplyOutputMessage');

  const handleSave = () => {
    onSave();
    setHasSaved(true);
  };

  const actions = (
    <div className="flex items-center gap-3">
      <SIMPLButtonCustomized
        label={t('Cancel')}
        secondary
        buttonHandlerAction={onCancel}
      />
      {isApplyMode ? (
        <SIMPLButtonCustomized
          label={isLoading ? t('Applying') : confirmLabel}
          primary
          buttonHandlerAction={onConfirm}
        />
      ) : (
        <SIMPLButtonCustomized
          label={t('Save')}
          primary
          buttonHandlerAction={handleSave}
        />
      )}
    </div>
  );

  return (
    <SIMPLModal
      title={title}
      onClose={onCancel}
      actions={actions}
      testId="fill-output-message-modal"
    >
      <p className="mb-4 text-[#002B6E]">{description}</p>
      <div className="bg-[#F5F7FA] rounded-lg p-4 text-sm text-[#4A4F5A] space-y-2">
        <div>
          <span className="font-semibold">{t('RequesterId')}:</span>{' '}
          <span data-test-id="fill-output-requester-id">{item.requesterUniqueId}</span>
        </div>
        <div>
          <span className="font-semibold">{t('Status')}:</span>{' '}
          <span data-test-id="fill-output-status">{item.resourceStatus}</span>
        </div>
      </div>
    </SIMPLModal>
  );
};
